import { render, staticRenderFns } from "./InlineEditReason.vue?vue&type=template&id=fdfa0448&scoped=true&"
import script from "./InlineEditReason.vue?vue&type=script&lang=js&"
export * from "./InlineEditReason.vue?vue&type=script&lang=js&"
import style0 from "./InlineEditReason.vue?vue&type=style&index=0&id=fdfa0448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfa0448",
  null
  
)

export default component.exports